"use client"
import { React } from "react";
import Breadcrumb from "@/components/Breadcrumbs/Breadcrumb";
import FileDirectory from "@/components/FileDirectory/FileDirectory";

const IncentivoBambues = () => {
    return <>
        <Breadcrumb pageName="Incentivo Bambúes" />
        <div className="space-y-4">
            <div className="bg-gray-100 rounded-2xl p-6 text-gray-800 leading-relaxed shadow-sm">
                <p>
                    🌿 El <strong>GAD Portoviejo</strong> impulsa la construcción sostenible
                    poniendo a su disposición la descarga gratuita de prototipos de vivienda.
                </p>

                <p className="mt-4">
                    Estos diseños están elaborados con <strong>caña guadúa</strong> y otros bambúes,
                    materiales ecológicos, duraderos y autóctonos de nuestro cantón.
                </p>

                <p className="mt-4 font-semibold">Cada paquete de descarga incluye:</p>

                <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Especificaciones técnicas detalladas 📄 </li>
                    <li>Requisitos constructivos 📐 </li>
                    <li>Normativas legales vigentes del cantón Portoviejo 📘 </li>
                </ul>

                <p className="mt-4">
                    ✔️ Asegure que su proyecto cumpla con los más altos estándares de seguridad,
                    calidad y regulación municipal.
                </p>

                <p className="mt-4">
                    ⬇️ Explore, descargue y construya con la confianza de tener el respaldo
                    técnico y legal.
                </p>

                <p className="mt-6 font-semibold text-center text-green-700">
                    ¡El GAD Portoviejo lo acompaña en el desarrollo de su proyecto!
                </p>
            </div>
            <FileDirectory
                data={[
                    {
                        id: 1,
                        name: "Prototipo 4",
                        type: "folder",
                        children: [
                            { id: 2, name: "Especificaciones Técnicas", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/dJLYKc6ziK87zPG/download" },
                            { id: 2, name: "Model Corte C", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/DwCPizZB3ePwn3a/download" },
                            { id: 2, name: "Model Corte J", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/xa379xr7YfERaic/download" },
                            { id: 2, name: "Model Fachada Frontal", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/qqDs78riL7HEwDj/download" },
                            { id: 2, name: "Model Fachada Lateral", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/PkXrS9bRto7eoDq/download" },
                            { id: 2, name: "Model Pers 1", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/3jMDRo3TRXNTXnA/download" },
                            { id: 2, name: "Model Pers 2", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/CF4zoeA5RydrNHQ/download" },
                            { id: 2, name: "Model Pers 3", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/jkdYwjm3AZ2n72S/download" },
                            { id: 2, name: "Model Planta Alta", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/LNZ7YmjASiQ5zyZ/download" },
                            { id: 2, name: "Model Planta Baja", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/gomC7aNoJR4WjmG/download" },
                            { id: 2, name: "IFMBE", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/dj5rBxMSoJXxG4e/download" },

                        ]
                    },
                    { id: 2, name: "Tipología 1", type: "file", fileType: "dwg", url: "https://nube.portoviejo.gob.ec/index.php/s/G5icni6WMD6Jw4X/download" },
                    { id: 2, name: "Tipología 2", type: "file", fileType: "dwg", url: "https://nube.portoviejo.gob.ec/index.php/s/AH2JyEQoTaqfTZt/download" },
                    { id: 2, name: "Tipología 3", type: "file", fileType: "dwg", url: "https://nube.portoviejo.gob.ec/index.php/s/TCXnZbYDBzogpq9/download" },
                    { id: 2, name: "Renders por tipología", type: "file", fileType: "pdf", url: "https://nube.portoviejo.gob.ec/index.php/s/mcEJsE2QHfS5qmH/download" },
                ]}
            />
        </div>

    </>
}

export default IncentivoBambues;